module.exports = __webpack_public_path__ + "img/logo.480320e7.jpg";